import React from 'react'
import AppLayout from '../../layout/components/AppLayout'

export default function SupportListPage() {
  return (
      <AppLayout>
        <div className="container">
            <div>Support List</div>
        </div>
      </AppLayout>
    
  )
}
